export default "__VITE_ASSET__ClvVg0Qj__"